import { render, staticRenderFns } from "./IconCertificate.vue?vue&type=template&id=18ac6ec2"
import script from "./IconCertificate.vue?vue&type=script&lang=js"
export * from "./IconCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports